import {
  DeviceRemoteDesktopSupportResponse,
  RemoteDesktopStatus,
} from './adapter/DeviceRemoteDesktopAdapter';
import { restClient } from '../../../../axios';
import _ from 'lodash';
import Util from '../../../../util/Util';
import { STAxiosInstance } from '../../../../axios/STAxios';

export class DeviceRemoteDesktopAPIService {
  readonly deviceConfigServiceURL = new Util().getDeviceConfigServiceURL();
  public constructor(private axios: STAxiosInstance = restClient) {}

  getDevicesRemoteDesktopSupport = async (
    deviceIds: string[]
  ): Promise<DeviceRemoteDesktopSupportResponse[]> => {
    if (!deviceIds.length) return [];

    if (deviceIds.length > 50) {
      // split it and call the api multiple times recursively
      // because the api can only handle 50 ids at a time
      const responses = await Promise.all(
        _.chunk(deviceIds, 50).map((chunk) => {
          return this.getDevicesRemoteDesktopSupport(chunk);
        })
      );
      return _.flatten(responses);
    }

    const response = await this.axios.post<Record<string, RemoteDesktopStatus>>(
      `${this.deviceConfigServiceURL}/remotecontrol/available`,
      deviceIds
    );

    // Convert map response { deviceId: enum } to array of
    // objects with deviceID field
    return Object.entries(response).map(([deviceId, status]) => ({
      deviceID: deviceId,
      status,
    }));
  };
}
